import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { reliablyHandleAsyncFormSubmit } from '../formUtils';
import { addImageDestinationLocation, requestImageDestinationLocationValidation } from  '../../../js/actions/imageLocationActionCreators';
import CreateImageDestinationLocationForm from './ImageDestinationLocationForm';

const validate = (values) => {
    const errors = {};

    if(isUndefinedNullOrEmpty(values.storageLocation)) {
        errors.storageLocation = 'Specify the image storage location';
    } else if(values.storageLocation.length > 450) {
        errors.storageLocation = 'image storage location path cannot have more than 450 characters';
    }

    return errors;
};

const validationStatus = {
    success: 'success',
    failed: 'failed',
    cancelled: 'cancelled'
};

const ImageDestinationLocationForm = CreateImageDestinationLocationForm('ImageDestinationLocationAddForm', validate);

const ImageDestinationLocationAddForm = React.createClass({
    setValidationSuccedded: null,
    setValidationFailed: null,
    propTypes: {
        forAgent: PropTypes.string.isRequired,
        onSuccess: PropTypes.func,
        onCancel: PropTypes.func,
        getOperation: PropTypes.func.isRequired,
        addImageDestinationLocation: PropTypes.func.isRequired,
        startImageDestinationValidation: PropTypes.func.isRequired
    },
    getInitialState: function() {
        return {
            validationOperationIdToTrack: null,
            validationStatus: null
        };
    },
    componentWillReceiveProps: function(nextProps) {
        const { getOperation } = nextProps;
        const { validationOperationIdToTrack } = this.state;

        if(!isUndefinedNullOrEmpty(validationOperationIdToTrack)) {
            const operation = getOperation(validationOperationIdToTrack);
            if(!isUndefinedNullOrEmpty(operation) && !isUndefinedNullOrEmpty(operation.resultDetails)) {
                const { resultDetails } = operation;
                if(resultDetails.isSuccess === true) {
                    this.setValidationSuccedded();
                } else {
                    this.setValidationFailed(resultDetails.errorMessage);
                }

                this.setState({
                    validationOperationIdToTrack: null,
                    validationStatus: resultDetails.isSuccess ? validationStatus.success : validationStatus.failed
                });
            }
        }
    },
    handleSubmit: function(data) {
        const { addImageDestinationLocation, startImageDestinationValidation, forAgent, onSuccess } = this.props;
        const imageDestinationLocationToAdd = { value: data.storageLocation };
        
        return reliablyHandleAsyncFormSubmit(() => {
            this.setState({ validationStatus: null });
            return startImageDestinationValidation(forAgent, data.storageLocation).then((operationDetails) => {
                this.setState({ validationOperationIdToTrack: operationDetails.id });
                return new Promise((resolve, reject) => {
                    this.setValidationSuccedded = resolve;
                    this.setValidationFailed = reject;
                });
            }).then(() => addImageDestinationLocation(imageDestinationLocationToAdd)).then(addedImageDestinationLocation => {
                if(onSuccess) {
                    onSuccess(addedImageDestinationLocation);
                }
            });
        });
    },
    render: function () {
        const { onCancel } = this.props;
        return <ImageDestinationLocationForm actionName="Add" onValid={this.handleSubmit} onCancel={onCancel} />;
    }
});

const mapStateToProps = (state) => ({
    getOperation: (operationId) => state.operations.value.get(operationId)
});

const mapDispatchToProps = (dispatch) => ({
    addImageDestinationLocation: (imageDestinationLocation) => {
        return dispatch(addImageDestinationLocation({ uncPath: imageDestinationLocation.value }));
    },

    startImageDestinationValidation: (agentId, uncPath) => {
        return dispatch(requestImageDestinationLocationValidation({
            agentId: agentId,
            uncPath: uncPath
        }));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageDestinationLocationAddForm);


// WEBPACK FOOTER //
// ./src/components/common/ImageDestinationLocationSelection/ImageDestinationLocationAddForm.jsx